import { useJobFilters } from 'lib/repositories/jobsShowcaseFilters';

import { AsyncSelectFocus } from '../../asyncSelectFocus';
import { MobileFilterCard } from '../card';

export const Focus = ({
  expands,
  handleSearchJobs,
}: {
  expands?: boolean;
  handleSearchJobs(): void;
}) => {
  const { setFocuses, filters } = useJobFilters();

  const resetFilter = () => {
    setFocuses([]);
  };

  return (
    <>
      <MobileFilterCard
        isActive={!!filters.focuses && filters.focuses.length > 0}
        showTooltip={false}
        showResetFilter
        resetFilter={resetFilter}
        label='Foco de Carreira'
        title='Foco de Carreira'
        handleSearchJobs={handleSearchJobs}
      >
        <AsyncSelectFocus expands={expands} onlyActiveJobs />
      </MobileFilterCard>
    </>
  );
};
